import waterfallComponents from "@/components/contents/waterfallComponents.vue"; //瀑布流
// 方法
import {
  fomatterNum,
  formatDate,
  getCookie,
  goToMini,
  isUserLogin,
  globalGoLogin,
  Debounce,
} from "@/assets/js/common.js";
import {
  xmhh5CommunityClick_fn,BuiedPointClick_Fn, xmhh5_community_expo_fn
} from "@/assets/js/BuriedPointEvent.js";

export default {
  name: "communityContentList",
  data() {
    return {
      communityTabList: [],
      currentId: null,
      pageParams: {
        page: 1,
        size: 10,
        error: false,
        loading: false,
        bottomText: "",
        finished: false,
      }, // 分页配置参数
      dataList: [],
      prevClickId: 0,
      userInfo: {},
      currentOffsetTop: 0,
    };
  },
  props: [],
  components: {
    waterfallComponents,
  },
  created() {
  },
  computed: {
  },
  mounted() {

    this.userInfo = !isUserLogin() ? JSON.parse(localStorage.getItem("userInfo")) : {};
    this.querySeedingTag();
  },
  methods: {
    fomatterNum,
    formatDate,
    goToMini,
    clickHander(data) {
      console.log(data.content,'data.title');
      xmhh5CommunityClick_fn("xmhh5CommunityClick", {
        xmhh5_Community_HomeArticle_Click: "星妈会H5社区首页内容点击",
      })
      this.$router.push({
        path: '/communityDetail/' + data.contentId
      })
    },
    querySeedingTag() {
      this.$http.get("/seeding/querySeedingTag", {}, (res) => {
        console.log(res)
        if (res.code === 200) {
          this.communityTabList = res.data || [];
          this.currentId = this.communityTabList[0].id
          this.prevClickId = this.communityTabList[0].id
          this.getArticleList()
        } else {
          this.$toast({
            duration: 2000,
            message: res.message || "获取专题失败！",
            context: this
          })
        }
      }, (err) => {
        console.log(err, 'error')
      }, 'lucky')
    },
    // 点赞，取消点赞
    handleLike: Debounce(function (data, index) {
      // 未登录，跳转登录，已登录调用接口
      if (isUserLogin()) {
        globalGoLogin()
      } else {
        xmhh5CommunityClick_fn("xmhh5CommunityClick", {
          xmhh5_Community_HomeArticle_Support: "星妈会H5社区首页内容点赞",
        })
        this.$http.post("/seeding/eventContent", {}, {
          contentId: data.contentId,
          crmId: this.userInfo?.crm_id || getCookie("xmh_unionid"),
          type: 2,
          state: !data.likeState,
        }, (res) => {
          if (res.code === 200) {
            this.$refs['waterfall' + this.currentId][0].curList[index].likeState = res.data.likeState;
            this.$refs['waterfall' + this.currentId][0].curList[index].likeNum = res.data.likeNum;
          } else {
            this.$toast(res.message || "点赞失败！")
          }
        }, (err) => {
          console.log(err, 'error')
        }, 'lucky')
      }
    }),
    // 切换专题
    changeIndex(id, title) {
      xmhh5CommunityClick_fn("xmhh5CommunityClick", {
        xmhh5_Community_ContTitle_Click: title,
      })
      if (this.prevClickId === id) {
        // 如果当前专题标题在页面顶部，则页面滚动到banner的高度，否则滚动到0
        if(this.$refs.tabRef.stickyFixed){
          this.$parent.$parent.$el.scrollTo({
            left: 0,
            top: this.currentOffsetTop,
            behavior: 'smooth'
          })
        }
      } else {
        this.pageParams.page = 1;
        this.getArticleList()
      }
      this.prevClickId = id;

    },
    getArticleList() {
      if (this.pageParams.page == 1) {
        // this.dataList = [];
        this.pageParams.finished = false;
      }
      this.pageParams.loading = true;
      this.$http.get(
        "/seeding/queryContentByTag",
        {
          tagId: this.currentId,
          crmId: this.userInfo?.crm_id || getCookie("xmh_unionid"),
          pageNum: this.pageParams.page,
          pageSize: this.pageParams.size,
        },
        (res) => {
          if (res.code == 200) {
            const { data, total } = res.data;
            let id = this.currentId;
            this.$refs['waterfall' + id][0].initData(this.pageParams.page > 1 ? 'push' : "init", data);
            this.$nextTick(() => {
              this.currentOffsetTop = this.$refs.tabRef.$parent.$el.offsetTop + 1;
              // 切换分类时，判断是否切换的其他分类，并且当前的分类时吸顶的，将页面滚动到指定位置
              if(this.pageParams.page == 1 && this.$refs.tabRef.stickyFixed){
                this.$parent.$parent.$el.scrollTo({
                  left: 0,
                  top: this.currentOffsetTop,
                  behavior: 'smooth'
                })
              }
              if ((this.pageParams.page * this.pageParams.size) >= total) {
                this.pageParams.finished = true;
              } else {
                this.pageParams.page++;
              }


              this.$nextTick(()=> {
                xmhh5_community_expo_fn.observe("xmhh5CommunityExpo", ".water-fall-item", false)
              })

            });
          } else {
            this.$toast("网络异常");
            this.pageParams.loading = false;
            this.pageParams.error = true;
            this.isDisabled = false;
          }
        },
        (err) => {
          console.log("error=========", err);
        }, 'lucky'
      );
    },
    // 瀑布流样式完毕
    styleEnd() {
      this.pageParams.loading = false;
    },
  }
}